import { call, put, take, takeEvery } from 'redux-saga/effects';
import * as storage from 'utils/storage';
import { fetchDevices, fetchDevice, updateDevice } from 'store/actions/deviceActions';
import Api from 'api/devices';

export function* fetchDevicesSaga() {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchDevices, {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: fetchDevices.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchDevices.success, payload: err.message });
  }
}

export function* fetchDeviceSaga(action: any) {
  const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
  const response = yield call(Api.fetchDevice(action.payload.serialKey), {
    headers: { 'x-blu-jwt': `${accessToken}` },
  });
  yield put({ type: fetchDevice.success, payload: response.data });
}

export function* updateDeviceSaga(action: any) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.putDevice(action.payload.serial, action.payload), {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: updateDevice.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: updateDevice.failure, payload: err.message });
  }
}

export function* watchUpdateDevice() {
  yield takeEvery(updateDevice.request, updateDeviceSaga);
}

export function* watchFetchDevice() {
  yield takeEvery(fetchDevice.request, fetchDeviceSaga);
}

export function* watchFetchDevices() {
  yield take(fetchDevices.request);
  yield call(fetchDevicesSaga);
}
